import { put } from 'typed-redux-saga';
import { uppyUploadError, uppyUploadFilesAddedFailure } from '../../../actions';
import { Uppy } from '@brandfolder/uploader';

export function* handleUploadExceedsStorageLimit(uppy: Uppy) {
  if (uppy) uppy.cancelAll();
  yield put(uppyUploadFilesAddedFailure());
  yield put(uppyUploadError({ uploadErrorType: 'uploadExceedsPlanStorageLimitError' }));
}